export default ({ data, functions }) => {
  const { dispatch, sendCvars } = functions;

  dispatch(sendCvars(data));
};
